import { render, staticRenderFns } from "./patient_card_selectuser_querydept.vue?vue&type=template&id=8f08a990"
import script from "./patient_card_selectuser_querydept.vue?vue&type=script&lang=js"
export * from "./patient_card_selectuser_querydept.vue?vue&type=script&lang=js"
import style0 from "./patient_card_selectuser_querydept.vue?vue&type=style&index=0&id=8f08a990&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports